
  import {Component, Vue} from 'vue-property-decorator';
  import {IReport} from "@/modules/Report/interfaces/report.interface";
  import ReportTable from "@/modules/Report/components/ReportTable.vue";
  import {ReportPrintActions} from "@/modules/Report/mixins/print-data.mixin";
  import {IApp} from "@/interfaces/app.interface";
  import {ICamsPhoto} from "@/modules/Car/interfaces/cams-photo.interface";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import {bus} from "@/plugins/bus";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import {httpResource} from "@/resources/http.resource";
  import EventCell from "@/modules/Report/components/events/EventCell.vue";
  import CarNumberCell from "@/modules/Report/components/events/CarNumberCell.vue";
  import _ from "lodash";

  @Component({
    components: {
      CarNumberCell,
      EventCell,
      ReportTable,
    }
  })
  export default class ReportTableEvents extends Vue {
    EventCell = EventCell;
    CarNumberCell = CarNumberCell;

    get tableList(): IReport.IEvent[] { return this.$store.getters['report/sortedList'].array; }
    get dataProps(): IReport.ITableProp[] {
      let actions = [{ tooltip: 'Смотреть фото', icon: 'camera', actionClick: this.openMediaPopup, },];
      if (this.$route.params.movId) {
        actions.push({ tooltip: 'Скорректировать дату заезда', icon: 'calendar-check', actionClick: (row) => this.openEditMovement(row), });
      }
      return [
        {
          label: 'Номер автомобиля',
          prop: 'carNumber',
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'CarNumberCell',
        },
        { label: 'ФИО',              prop: 'persName',  propType: IApp.SortingPropType.String, colspan: 2, },
        { label: 'Корпорация',       prop: 'corpName',  propType: IApp.SortingPropType.String, colspan: 2, },
        { label: 'Дата события',     prop: 'dateEvent', propType: IApp.SortingPropType.Date, dateFormat: IApp.DateFormats.PrintedDateTimeFull, colspan: 2, },
        {
          label: 'Событие',
          prop: 'eventName',
          propType: IApp.SortingPropType.CustomComponent,
          customComponentName: 'EventCell',
        },
        { label: 'Парковка',         prop: 'parkName',  propType: IApp.SortingPropType.String, },
        { label: 'Комментарий',      prop: 'comment',   propType: IApp.SortingPropType.String, colspan: 3, },
        { label: 'Действия',         prop: 'actions',   propType: IApp.SortingPropType.Actions, actions,
        }
      ];
    }
    get printedOptions() {
      return {
        $options: this.$options,
        tableList: this.tableList,
        dataProps: this.dataProps,
      };
    }

    async mounted() {
      bus.$on(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.ReportEvents,
        async ({ indexRow, direction }) => {
        let index = indexRow;
        if (direction === +1) index = indexRow === this.tableList.length - 1 ? 0 : indexRow + direction;
        else index = indexRow === 0 ? this.tableList.length - 1 : indexRow + direction;
        await this.openMediaPopup(this.tableList[index], index, true);
      });

    }

    async reloadData() {
      await this.$store.dispatch('report/getReport', {
        reportName: this.$store.state.report.activeReport,
        filters: {...this.$store.state.report.filters},
      });
    }

    printTable() {
      ReportPrintActions.PrintTable(this.printedOptions);
    }

    prepareExcel() {
      return ReportPrintActions.PrepareExcel(this.printedOptions);
    }

    async openMediaPopup(item: IReport.IEvent, index: number, fromPopup = false) {
      if (!item.hasPhoto) return;

      const resourcePayload: ICamsPhoto.IPayloadCams = {
        camId: item.number,
        carNumber: item.carNumber,
        dateEvent: item.dateEvent,
        intervalMinutes: item.intervalMinutes,
      };
      const { response } = await ICamsPhoto.GetCamsPhoto(resourcePayload);
      const mediaPayload: IAppMediaPopup.IPayload = {
        files: response && response.length ? response : [],
        fileErrorText: !item.carNumber ? 'Не было фиксации на данный период' : '',
        parentList: {
          name: IAppMediaPopup.MediaPopupSourceCall.ReportEvents,
          currentIndex: index,
          total: this.tableList.length,
        },
        mediaInfo: {
          carNumber: item.carNumber,
          props: [
            { cells: [
                { label: 'Дата события: ', value: this.$options.filters.moment(item.dateEvent, IApp.DateFormats.PrintedDateTimeFull) },
              ]
            },
            { cells: [
                { label: 'ФИО: ', value: item.persName },
                { label: 'Корпорация: ', value: item.corpName },
              ]
            },
          ],
        }
      };
      if (!fromPopup) {
        await this.$store.dispatch('dialog/openDialog', {
          blockName: 'allPages',
          dialogName: 'appMediaPopup',
          payload: {
            ...mediaPayload,
          },
        });
      }
      else {
        this.$store.commit('dialog/updateActivePopupPayload', mediaPayload);
        await this.$store.dispatch('dialog/reloadPopup');
      }
    }

    async openEditMovement(row: IReport.IEvent) {
      let asyncAction = async () => {
        const action = ICarList.Action.CarsMove;
        const params: any = {
          command: ICarList.CommandsMovements.Update,
          movId: this.$route.params.movId,
          carNumber: row.carNumber,
          dateIn: row.dateEvent,
          corpId: row.corpId,
          comment: 'Корректировка даты заезда',
          movsRecalcFlag: true,
          searchFlag: true,
        };
        await httpResource.httpAction({ action, params });
      };
      let response = await this.$store.dispatch('defaultResourceAction', { asyncAction });
      if (response.success) {
        bus.$notify({ title: 'Успешно', message: 'Дата заезда скорректирована', type: 'success' });
        await this.$store.dispatch('openPage', {routeName: IApp.ROUTE_NAME.PAGE_BARRIERS});
      }
    }

    destroyed() {
      bus.$off(IAppMediaPopup.EmitterEvents.ToggleEntityTo + IAppMediaPopup.MediaPopupSourceCall.ReportEvents);
    }
  }
